"use client";

import styled from "styled-components";

export const TitleContainer = styled.div`
  display: flex;
  padding-bottom: var(--Spacing-8, 0.8rem);
  gap: 0.8rem var(--Spacing-8, 0.8rem);
`;
